import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
import useWishlistStore from '../store/useWishlistStore';
import useAuthStore from '../store/useAuthStore';
import useCartStore from '../store/useCartStore';

const MainLayout = () => {
  const { isAuthenticated } = useAuthStore();
  const { fetchWishlist } = useWishlistStore();
  const { getCart } = useCartStore();

  // Fetch cart & wishlist on mount and auth change
  useEffect(() => {
    getCart();
    if (isAuthenticated) {
      fetchWishlist();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const applyTheme = async () => {
      try {
        const { data } = await axios.get('/settings');
        const settings = data.data || data || {};

        if (settings.themeColors) {
          const root = document.documentElement;

          if (settings.themeColors.primaryColor) {
            const hex = settings.themeColors.primaryColor;
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            root.style.setProperty('--color-primary', `${r} ${g} ${b}`);
            root.style.setProperty('--color-primary-hex', hex);
          }

          if (settings.themeColors.secondaryColor) {
            const hex = settings.themeColors.secondaryColor;
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            root.style.setProperty('--color-secondary', `${r} ${g} ${b}`);
            root.style.setProperty('--color-secondary-hex', hex);
          }
        }
      } catch (error) {
        console.error('Tema renkleri yüklenemedi:', error);
      }
    };

    applyTheme();
  }, []);

  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={`flex-grow ${isHomePage ? '' : 'pt-20'}`}>
        <Outlet />
      </main>
      <ScrollToTopButton />
      <Footer />
    </div>
  );
};

export default MainLayout;

